export enum Network {
  ONLINE = 'online',
}
